export default "__VITE_ASSET__CvzTEZnT__"